import { render, staticRenderFns } from "./QuestionnaireFooter.vue?vue&type=template&id=5efabdd3&scoped=true&"
import script from "./QuestionnaireFooter.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireFooter.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireFooter.vue?vue&type=style&index=0&id=5efabdd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efabdd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
